import React from 'react';
import { reportClientError } from '../services/api';

class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
    this.handleReload = this.handleReload.bind(this);
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('[AppErrorBoundary] Unhandled error', error, info);
    
    // Report to incident tracking
    reportClientError({
      severity: 'critical',
      errorCode: 'REACT_ERROR_BOUNDARY',
      message: error.message || 'Unhandled React error',
      meta: {
        stack: error.stack,
        componentStack: info?.componentStack,
        url: window.location.href,
      },
    });
  }

  handleReload() {
    this.setState({ error: null }, () => {
      window.location.reload();
    });
  }

  render() {
    const { error } = this.state;
    const { children } = this.props;
    if (error) {
      return (
        <div className="app-error-fallback">
          <div className="error-card">
            <span className="auth-badge">KI Chat</span>
            <h1>Noe gikk galt</h1>
            <p>En uventet feil hindret oss i å laste inn dashboardet. Prøv å laste siden på nytt.</p>
            <pre className="error-details">{error.message}</pre>
            <button type="button" className="button button-primary" onClick={this.handleReload}>
              Last inn på nytt
            </button>
          </div>
        </div>
      );
    }
    return children;
  }
}

export default AppErrorBoundary;
